import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {PageNotFoundComponent} from '@core-components/page-not-found/page-not-found.component';
import {
  PrintApplicationComponent
} from "@features/leads/applications/print-application/print-application.component";
import {
  PreviewSurveyFormComponent
} from "@features/leads/surveys/survey-view/preview-survey-form/preview-survey-form.component";
import {PoliciesComponent} from "@features/support/policies/policies.component";
import {LoginComponent} from "@features/login/login.component";
import {ForgotPasswordComponent} from "@features/password-reset/forgot-password/forgot-password.component";
import {CheckYourEmailComponent} from "@features/password-reset/check-your-email/check-your-email.component";
import {ResetPasswordComponent} from "@features/password-reset/password-reset/password-reset.component";
import {
  VerifyUpdatePasswordOtpComponent
} from "@features/password-reset/verify-update-password-otp/verify-update-password-otp.component";
import {VerifyAccountComponent} from "@features/verify-account/verify-account.component";
import {canActivate as pathContextGuard} from "@core-guards/path-context-guard.service";
import {HomeScreenComponent} from "@core-components/home-screen/home-screen.component";
import {canActivate as routeGuard} from "@core-guards/route/auth.guard";
import {
  PreviewApplicationFormComponent
} from "@features/leads/application-form-builder/preview-application-form/preview-application-form.component";


const routes: Routes = [
  {path: 'policies', component: PoliciesComponent},


  {path: '404', component: PageNotFoundComponent},
  {path: 'preview-apply/:formCode', component: PreviewApplicationFormComponent},
  {path: 'preview-survey/:formCode', component: PreviewSurveyFormComponent},
  {
    path: 'print/application',
    component: PrintApplicationComponent
  },
  {
    path: ':clientId',
    children: [
      {path: 'hello', redirectTo: ':clientId/login', pathMatch: 'full'},
      {path: 'login', component: LoginComponent},
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
      },
      {path: 'forgot-password/check-your-email', component: CheckYourEmailComponent},
      {path: 'forgot-password/password-reset', component: ResetPasswordComponent},
      {path: 'forgot-password/verify', component: VerifyUpdatePasswordOtpComponent},
      {
        path: 'account/verify',
        component: VerifyAccountComponent,
        canActivate: [pathContextGuard]
      },
      {
        path: 'approval',
        component: HomeScreenComponent,
        canActivate: [routeGuard, pathContextGuard],
        data: { openTab: true }
      },
      {
        path: '',
        component: HomeScreenComponent,
        canActivate: [routeGuard, pathContextGuard],
        data: { openTab: false }
      },
    ]

  },
  {path: '**', redirectTo: '/404', pathMatch: 'full'},
]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
